/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFilterFunnelIcon16Solid = forwardRef('UiFilterFunnelIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M14 2H2a1 1 0 0 0-1 1v1.719c0 .49.239.948.64 1.229L5.573 8.7a1 1 0 0 1 .427.82v5.175a1 1 0 0 0 1.53.848l2-1.25a1 1 0 0 0 .47-.848V9.52a1 1 0 0 1 .427-.82l3.933-2.753A1.5 1.5 0 0 0 15 4.719V3a1 1 0 0 0-1-1Z" })));
});
